import { MenuItem } from "@mui/material";
import { doApiPost } from "../../api/Requests";
import { authenticationStateHandler } from "../logic/AuthenticationStateHandler";
import { useTranslation } from "react-i18next";
import { clearPermissions } from "../../store/reducers/permissionsReducer";
import { useAppDispatch } from "../../hooks/StoreHooks";

export default function LogoutButton() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleLogout = async () => {
        try {
            await doApiPost<any, never>(
                "/api/logout",
                {},
                { credentials: "include" }
            );
        } catch (error) {
            console.warn("Logout request failed", error);
        } finally {
            localStorage.removeItem("userRole");
            dispatch(clearPermissions());
            authenticationStateHandler.setNotAuthenticated();
        }
    };

    return <MenuItem onClick={handleLogout}>{t("profilePage.logout")}</MenuItem>;
}